import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// import "./plugins/google-maps";
import "./plugins/VeeValidate";
import axios from "axios"; // axios
import cookie from "js-cookie"; // js-cookie
import "./assets/scss/main.scss"; // Styles: SCSS
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import wb from "./registerServiceWorker";
import VueCurrencyFilter from "vue-currency-filter";
import JsonExcel from "vue-json-excel";
import Cookies from "js-cookie";

Vue.component("downloadExcel", JsonExcel);

Vue.use(VueCurrencyFilter, {
  symbol: "Rp.",
  thousandsSeparator: ".",
  fractionCount: 0,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true
});

Vue.prototype.$workbox = wb;
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
Vue.use(require("vue-moment"));
Vue.config.productionTip = false;
const axiosOptoins = {
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 180000, // 3 menit
  headers: {}
};
if (cookie.getJSON("userdata") !== undefined) {
  const auth = cookie.getJSON("userdata");
  store.commit("SET_LOGIN", auth);

  axiosOptoins.headers.Authorization = "Bearer " + auth.access_token;
  store.commit("retrieveToken", auth.access_token);
}
Vue.prototype.$axios = axios.create(axiosOptoins);

axios.interceptors.response.use(
  response => {
    if (response.status === 401) {
      // Cookies.remove('token')
      Cookies.set("expired", "true");
      // window.location.replace(link)
      store.commit("outlet/SET_TOKEN_EXPIRED", true);
    }
    return Promise.resolve(response);
  },
  error => {
    if (error.response.status === 401) {
      // Cookies.remove('token')
      Cookies.set("expired", "true");
      // window.location.replace(link)
      store.commit("system/SET_TOKEN_EXPIRED", true);
    } else {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
